@if (!services() || !graph()) {
  <app-card i18n>Loading data...</app-card>
} @else {
  @let serviceData = services()!;
  @let graphData = graph()!;
  <app-card>
    <div>
      <div i18n class="headline">Service calls last 30 days</div>
      <div i18n class="subheadline">Across all services</div>
    </div>
    <app-graph [data]="graphData.data" [options]="graphData.options" type="line"></app-graph>
    <div class="services">
      @for (service of serviceData; track service.id) {
        <app-metric-card [data]="service" />
      }
    </div>
  </app-card>
}
